'use client';

import { useEffect, useRef, useState } from 'react';
import { INITIAL_PROGRESS, PROGRESS_ITEMS, SEPARATOR_SELECTOR_CLASSNAME } from '../constant';
const clamp = (value: number) => Math.min(1, Math.max(0, value));
const ProgressBarContent = ({
  active = false
}: {
  active?: boolean;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = useState(INITIAL_PROGRESS);
  useEffect(() => {
    if (!active) {
      setProgress(INITIAL_PROGRESS);
      return;
    }
    let frameId: number | undefined;
    const updateProgress = () => {
      frameId = undefined;
      const bar = contentRef.current?.parentElement;
      const separators = Array.from(document.querySelectorAll<HTMLElement>(`.${SEPARATOR_SELECTOR_CLASSNAME}`)).slice(0, PROGRESS_ITEMS.length);
      if (!bar || separators.length === 0) return;
      const triggerY = bar.getBoundingClientRect().bottom;
      const separatorTops = separators.map(separator => separator.getBoundingClientRect().top);
      const completedItems = separatorTops.filter(top => top <= triggerY).length;
      let lineProgress = 0;
      if (completedItems >= separators.length) {
        lineProgress = 1;
      } else if (completedItems > 0) {
        const currentTop = separatorTops[completedItems - 1];
        const nextTop = separatorTops[completedItems];
        const sectionProgress = clamp((triggerY - currentTop) / (nextTop - currentTop));
        lineProgress = (completedItems - 1 + sectionProgress) / (separators.length - 1);
      }
      setProgress(previous => previous.completedItems === completedItems && previous.lineProgress === lineProgress ? previous : {
        completedItems,
        lineProgress
      });
    };
    const scheduleUpdate = () => {
      if (frameId === undefined) frameId = requestAnimationFrame(updateProgress);
    };
    scheduleUpdate();
    window.addEventListener('scroll', scheduleUpdate, {
      passive: true
    });
    window.addEventListener('resize', scheduleUpdate);
    return () => {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      if (frameId !== undefined) cancelAnimationFrame(frameId);
    };
  }, [active]);
  const nextItem = PROGRESS_ITEMS[progress.completedItems];
  return <div ref={contentRef} className='flex w-full items-center gap-2 lg:mx-auto lg:max-w-[880px]' data-sentry-component="ProgressBarContent" data-sentry-source-file="progress.tsx">
            <div className='relative flex h-4 w-44 shrink-0 flex-row-reverse items-center justify-between lg:h-3 lg:w-auto lg:flex-1' role='progressbar' aria-valuemin={0} aria-valuemax={PROGRESS_ITEMS.length} aria-valuenow={progress.completedItems} dir='ltr'>
                <div className='absolute inset-x-1 h-0.5 bg-gray-200 lg:inset-x-1.5' />
                <div className='absolute inset-x-1 h-0.5 lg:inset-x-1.5' style={{
        background: 'linear-gradient(to left, #FFE66D, #DB2777)',
        clipPath: `inset(0 0 0 ${100 - progress.lineProgress * 100}%)`
      }} />
                {PROGRESS_ITEMS.map(({
        title,
        color
      }, index) => {
        const isComplete = index < progress.completedItems;
        return <span key={title} className='z-10 h-2 w-2 rounded-full border transition-colors duration-300 ease-out lg:h-3 lg:w-3' style={{
          backgroundColor: isComplete ? color : '#FFFFFF',
          borderColor: isComplete ? color : '#D4D4D4'
        }} aria-hidden='true' />;
      })}
            </div>
            <div className='flex h-4 flex-1 items-center gap-1 text-caption-12 lg:w-52 lg:flex-none lg:text-body-14'>
                {nextItem && <span>ایستگاه بعد:</span>}
                {nextItem && <span className='flex-1 text-center font-medium'>{nextItem.title}</span>}
            </div>
        </div>;
};
export default ProgressBarContent;